import React from 'react';
import './StatusBadge.css';

const StatusBadge = ({ status = 'Available', statusIcon }) => {
  const isAvailable = status === 'Available';
  
  return (
    <div className="status-badge">
      <div className={`status-dot-wrapper ${isAvailable ? 'sonar-active' : ''}`}>
        <div className="status-dot">
          <img src={statusIcon} alt="status indicator" />
        </div>
      </div>
      <span className="status-text">{status}</span>
    </div>
  );
};

export default StatusBadge;

